module.exports = __webpack_public_path__ + "img/Credential.f28b2b0c.png";